<template>
  <div class="animate__animated animate__fadeIn">
    <div class="row">
      <div class="col">
        <h5 class="font-weight-bold">Condições de Saúde</h5>
      </div>
      <!-- <div class="col text-right">
				<p class="font-weight-light font-italic">
					<a
						href="#"
						class="router-link-exact-active active"
						@click="show_historico = true"
					>
						<i class="fas fa-history"></i> Histórico
					</a>
				</p>
			</div> -->
    </div>

        <div class="row">
            <div class="col-md-12">
                <b-tabs content-class="mt-3">
                    <b-tab title="Saúde" active>
                        <div class="row">
                            <form-select
                                v-model="caracteristicas.ind_risco_inseguranca_alimentar"
                                grid="12"
                                label=" A família declara, ou fornece indícios, de que vivencia situação de insegurança alimentar devido à insuficiência de alimentos?"
                                :itens="$root.arrays.pergunta"
                            />
                        </div>
                        <div class="row pt-4 px-2 d-flex justify-content-end">
                            <!-- <div class="col-md-9">
								<div class="float-left mt-2 mr-3">
									<toggle-button
										:sync="true"
										color="#5685D8"
										id="abrigo"
										name="abrigo"
										v-model="item.cadastrarSaude"
										class="float-left mr-3"
									/>
									Cadastrar novas condição de saúde?
								</div>
							</div> -->
              <button
                class="btn btn-success btn-submit"
                data-style="zoom-in"
                @click="submit"
              >
                <i class="mdi mdi-content-save" />
                {{ $t("Salvar") }}
              </button>
            </div>

            <Medicamentos :item="item" />
          </b-tab>
          <b-tab title="Pessoa(s) com Deficiência">
            <Deficientes :item="item" />
          </b-tab>
          <b-tab title="Gestante(s)">
            <Gestantes :item="item" />
          </b-tab>
          <b-tab :title="`Condicionalidades ${$t('PBF')}`">
            <Condicionalidades :item="item" />
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import Gestantes from "./saude/Gestantes";
import Deficientes from "./saude/Deficientes";
import Condicionalidades from "./saude/Condicionalidade";
import Medicamentos from "./saude/Medicamento";

export default {
  components: { Gestantes, Deficientes, Condicionalidades, Medicamentos },
  props: ["item"],
  data() {
    return {
      domicilio: null, // Adicionado para evitar erro
      caracteristicas: { ind_risco_inseguranca_alimentar: null },
    };
  },
  mounted() {
    if (this.item.domicilio) {
      this.domicilio = { ...this.item.domicilio }; // Clonando para evitar modificações diretas
    }
    if (this.item.caracteristicas) {
      this.caracteristicas = { ...this.caracteristicas, ...this.item.caracteristicas }; // Mantendo valores iniciais
    }
  },
  methods: {
    submit() {
      this.item.domicilio = this.domicilio;
      this.item.caracteristicas = this.caracteristicas;
      this.$emit("submit");
    },
  },
};
</script>
